import React from "react";
import Dots from "react-activity/lib/Dots";
import "../../style/dots.css";

const OverlayIndicator = (props) =>{
    if(props.fetching){
        return (
            <div id={props.wholePage?'overlayWholePage':'overlay'}>
                <div id="overlayText">
                    <Dots/>
                </div>
            </div>
        );
    }
    return (null);
};

export default OverlayIndicator;

